import EChartsReact from "echarts-for-react";
import moment from "moment";
import React, { ReactElement, useEffect, useState } from "react";

export interface LineChartsProps {
  handle?: any[];
  error?: any[];
  style?: React.CSSProperties;
}

export const LineCharts: React.FC<LineChartsProps> = ({
  handle,
  error,
  style,
}): ReactElement => {
  const [LineOption, setLineOption] = useState<any>();
  useEffect(() => {
    if (handle || error) {
      const startIndex = Number(moment().format("M"));
      const xData = [
        "1月",
        "2月",
        "3月",
        "4月",
        "5月",
        "6月",
        "7月",
        "8月",
        "9月",
        "10月",
        "11月",
        "12月",
      ];
      const option = {
        grid: {
          left: "2%",
          right: "2%",
          bottom: "15em",
          top: "28em",
          containLabel: true,
        },
        tooltip: {
          trigger: "axis",
          formatter:
            "<font color='#13E2B8'>诊疗行为: {c0}</font><br /><font color='#027AFF'>预警数: {c1}</font>",
          backgroundColor: "#061F64",
          borderColor: "#061f64",
        },
        xAxis: {
          type: "category",
          data: xData.slice(startIndex).concat(xData.slice(0, startIndex)),
          splitLine: {
            show: false,
          },
          axisLabel: {
            interval: 0,
          },
        },
        yAxis: [
          {
            name: "诊疗行为",
            type: "value",
            splitNumber: 4,
            //网格线样式
            splitLine: {
              show: true,
              lineStyle: {
                color: ["#061F72"],
                width: 1,
                type: "solid",
              },
            },
            //Y轴样式
            axisLine: {
              show: true,
              symbol: ["none", "arrow"],
              lineStyle: {
                color: "#13E2B8",
              },
            },
            axisLabel: {
              show: true,
              min: 0,
              max: handle?.reduce((m, v) => Math.max(m, v), 0) || 100,
            },
          },
          {
            name: "预警数",
            type: "value",
            splitNumber: 3,
            //网格线样式
            splitLine: {
              show: true,
              lineStyle: {
                color: ["#061F72"],
                width: 1,
                type: "solid",
              },
            },
            //Y轴样式
            axisLine: {
              show: true,
              symbol: ["none", "arrow"],
              lineStyle: {
                color: "#027AFF",
              },
            },
            axisLabel: {
              show: true,
              min: 0,
              max: error?.reduce((m, v) => Math.max(m, v), 0) || 100,
            },
          },
        ],
        series: [
          {
            data: handle,
            type: "line",
            smooth: true,
            yAxisIndex: 0,
            lineStyle: {
              color: "#13E2B8",
            },
            emphasis: {
              focus: "series",
            },
          },
          {
            data: error,
            type: "line",
            smooth: true,
            yAxisIndex: 1,
            lineStyle: {
              color: "#027AFF",
            },
            emphasis: {
              focus: "series",
            },
          },
        ],
      };
      setLineOption(option);
    }
  }, [handle, error]);
  return (
    <>{LineOption && <EChartsReact option={LineOption} style={style} />}</>
  );
};
